// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"411":"15789ccd28621ad1","3877":"fe336940f98fdfab","5673":"ac2cc6732bbbc2f5","7395":"f295082876f1ea37"}[chunkId] + ".css";
};